import React, { useState } from "react";
import { useSelector } from "react-redux";
import { 
  AppBar, 
  IconButton, 
  Box 
} from "@mui/material";
import {
  Notifications
} from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';
import ProfileMenu from "../navProfile/ProfileMenu";
import DocsHelpLink from "../docs/DocsHelpLink";

const navItems = [
  // {
  //   name: "View Notifications",
  //   icon: <Notifications sx={{ fontSize: 24 }} />,
  //   action: "handleViewNotifications",
  // },
];

const Navbar = () => {
  const theme = useTheme();
  const auth = useSelector((state) => state.auth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const user = auth?.user;

  // Toggle Profile Menu
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  // Action Handlers
  const handleViewNotifications = () => {
    alert("View Notifications Clicked");
  };

  // Map action names to functions
  const actionHandlers = {
    handleViewNotifications,
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.secondary.main,
        height: 43,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Left Section (Placeholder for Branding or Navigation) */}
      <Box sx={{ flexGrow: 1 }}>
        {/* You can place a logo or title here */}
      </Box>

      {/* Right Section (Icons & Profile) */}
      <Box 
       sx={{ 
        display: "flex", 
        alignItems: "center", 
        padding: "0px 10px"
       }}>
        {navItems.map((item) => (
          <IconButton
            key={item.name}
            onClick={actionHandlers[item.action]}
            sx={{
              color: theme.palette.customColors.light,
            }}
          >
            {item.icon}
          </IconButton>
        ))}

        <DocsHelpLink />

        {/* Profile Menu */}
        <ProfileMenu 
          user={user}
          isMenuOpen={isMenuOpen}
          toggleMenu={toggleMenu}
        />
      </Box>
    </Box>
  );
};

export default Navbar;
